module.exports = "<p>\n  login-admin works!\n</p>\n"